<template>
   <v-container>
      <v-layout justify-center text-xs-center wrap>
         <v-flex md8>
            <v-stepper v-model="e6" vertical>
               <v-stepper-step editable :complete="e6 > 1" step="1">
                  Trustor information
               </v-stepper-step>
               <!-- Trustor fields -->
               <v-stepper-content step="1">
                 <TrustorIndividual :trustor="trustor"/>
                 <AdditionalTrustors :cotrustors="cotrustors" @deleteTrustor="onDeleteTrustor($event)" />
                  <p> Is Trustor a corporation? </p>
                  <v-btn data-btn="iscorporation"  @click.native="e6 = 2;">Corporation</v-btn>
                  <v-btn data-btn="notcorporation" color="primary" @click.native="e6 = 3">Individual</v-btn> 
               </v-stepper-content>

               <v-stepper-step editable :complete="e6 > 2" step="2"> Corporation information <small>Optional</small>
               </v-stepper-step>
               <v-stepper-content step="2">
                  <!-- Aircraft Fields -->
                 <CorporationInformation :corporation="corporation"/>
                  <v-btn data-btn="corporation-previous" flat @click.native="e6 = 1">Previous</v-btn>
                  <v-btn data-btn="corporation-continue" color="primary" @click.native="e6 = 3">Continue</v-btn>
               </v-stepper-content>

              
               <v-stepper-step editable :complete="e6 > 3" step="3">Aircraft information</v-stepper-step>
               <v-stepper-content step="3">
                  <!-- Aircraft Fields -->
                  <AircraftInformation :aircraft="aircraft"/>
                  <v-btn data-btn="aircraft-previous" flat @click.native="e6 = 2">Previous</v-btn>
                  <v-btn data-btn="aircraft-continue" color="primary" @click.native="e6 = 4">Continue</v-btn>
               </v-stepper-content>
               
               <v-stepper-step editable :complete="e6 > 4" step="4">Operator Information</v-stepper-step>
               <v-stepper-content step="4">
                  <!-- Trust Operator -->
                  <v-btn data-btn="trustor-as-operator" color="info" @click.native="trustorAsOperator(trustor,operator)">Copy from Trustor</v-btn>
                  <OperatorInformation :operator="operator"/>
                  <AdditionalOperators :cotrustors="cotrustors" :cooperators="cooperators" @deleteOperator="onDeleteOperator($event)" @coTrustorsToOperators="coTrustorsToOperators()"/>
                   <v-btn data-btn="operator-previous" flat @click.native="e6 = 3">Previous</v-btn>
                  <v-btn data-btn="operator-continue" color="primary" @click.native="e6 = 5">Continue</v-btn>
               </v-stepper-content>
               
               <v-stepper-step editable :complete="e6 > 5" step="5">Trust Agreement Details</v-stepper-step>
               <v-stepper-content step="5">
                  <!-- Trust Metadata -->
                  <TrustDetails :trust="trust" :flight="flight"/>

                  <p> Who is the Trustee? </p>
                  <v-btn data-btn="custom-trustee" flat @click.native="e6 = 6;">Start a company</v-btn> 
                  <v-btn data-btn="ias-trustee" color="primary" @click.native="e6 = 7">IAS</v-btn>
               </v-stepper-content>

               <v-stepper-step editable :complete="e6 > 6" step="6">Trustee Details <small>Optional</small> </v-stepper-step>
               <v-stepper-content step="6">
                  <!-- Trustee Information -->
                  <TrusteeInformation :trustee="trustee"/>
                  <v-btn data-btn="trustee-previous" flat @click.native="e6 = 5">Previous</v-btn>
                  <v-btn data-btn="trustee-next" color="primary" @click.native="e6 = 7">Next</v-btn>
               </v-stepper-content>

               <v-stepper-step editable :complete="e6 > 7" step="7">Done </v-stepper-step>
               <v-stepper-content step="7">
                 <PinCodeForm :pin.sync="pinCode" />
                  <DocumentDisplay />
                  <v-btn data-btn="done-previous" flat @click.native="e6 = 6">Previous</v-btn>
                  <v-btn data-btn="done-submit" :disabled="!pinCode" color="primary" @click.prevent="submit" class="generate-button">Generate documents</v-btn>
               </v-stepper-content>

            </v-stepper>
         </v-flex>

         <v-flex md2 v-if="env != 'prod'">
           <span>
           <h1> Debug </h1>
           <p> {{trustor}}</p>
           <p> {{aircraft}}</p>
           <p> {{trust}}</p>
           <p> {{operator}} </p>
           <p> is custom trustee {{isCustomTrustee}} </p>
           <p> {{trustee}} </p>
           <p> is corporation: {{isCorporationTrustor}} </p>
           <p> {{corporation}} </p>
           <p> {{docs}}</p>
           <p> {{pdfs}}</p>  
           </span>
         </v-flex>

      
      </v-layout>
   </v-container>
</template>

<script>
import TrustorIndividual from "./TrustorIndividual.vue";
import AircraftInformation from "./AircraftInformation.vue";
import OperatorInformation from "./OperatorInformation.vue";
import TrustDetails from "./TrustDetails.vue";
import TrusteeInformation from "./TrusteeInformation.vue";
import CorporationInformation from "./CorporationInformation.vue";
import AdditionalTrustors from "./AdditionalTrustors.vue";
import AdditionalOperators from "./AdditionalOperators.vue";
import DocumentDisplay from "./DocumentDisplay.vue";
import PinCodeForm from "./PinCodeForm.vue";

export default {
  name: "trust-form",
  components: {
    TrustorIndividual,
    AircraftInformation,
    OperatorInformation,
    TrustDetails,
    TrusteeInformation,
    CorporationInformation,
    AdditionalTrustors,
    AdditionalOperators,
    DocumentDisplay,
    PinCodeForm
  },
  data: () => ({
    e6: 1,
    env: process.env.NAME,
    trustor: {
      title: "Individual", // Default value
      areacode: "011"
    },
    aircraft: {},
    trust: {},
    operator: { name: "" }, // If you don't initialize fields here, Vue won't detect changes to the model
    flight: {},
    corporation: {},
    trustee: {},
    cotrustors: [],
    cooperators: [],
    pinCode: ""
  }),
  computed: {
    pdfsLoading() {
      return this.$store.getters.loadingPdfs;
    },
    docsLoading() {
      return this.$store.getters.loadingDocs;
    },
    pdfs() {
      return this.$store.getters.pdfs;
    },
    docs() {
      return this.$store.getters.docs;
    },
    isCorporationTrustor() {
      if (
        this.corporation.name ||
        this.corporation.signer ||
        this.corporation.signer ||
        this.corporation.origin ||
        this.corporation.title
      ) {
        return true;
      }
      return false;
    },
    isCustomTrustee() {
      if (
        this.trustee.name ||
        this.trustee.address ||
        this.trustee.city ||
        this.trustee.postalcode ||
        this.trustee.origin
      ) {
        return true;
      }
      return false;
    }
  },
  methods: {
    submit() {
      let payload = {
        trustor: this.trustor,
        operator: this.operator,
        aircraft: this.aircraft,
        trust: this.trust,
        flight: this.flight,
        pin: this.pinCode
      };
      if (this.isCorporationTrustor) {
        payload.trustor.corporation = this.corporation;
      }

      if (this.operator.origin) {
        payload.operator.corporation = {
          signer: this.operator.signer,
          title: this.operator.title,
          origin: this.operator.origin
        };
      }

      if (this.isCustomTrustee) {
        payload.trustee = this.trustee;
      }
      if (this.cotrustors.length > 0) {
        payload.trustor.cotrustors = this.cotrustors;
      }
      if (this.cooperators.length > 0) {
        payload.operator.cooperators = this.cooperators;
      }

      this.$store.dispatch("loadDocs", payload);
      this.$store.dispatch("loadPdfs", payload);
    },
    trustorAsOperator: function(trustor) {
      if (trustor.middleName) {
        this.operator.name = [
          trustor.firstName,
          trustor.middleName,
          trustor.lastName
        ].join(" ");
      } else {
        this.operator.name = [trustor.firstName, trustor.lastName].join(" ");
      }

      this.operator.address = `${trustor.address} ${trustor.city} ${
        trustor.postalCode
      } ${trustor.country}`;
      this.operator.phone = trustor.areacode + " " + trustor.phone;
      this.operator.email = trustor.email;
      this.operator.communication = trustor.email;

      if (this.isCorporationTrustor) {
        this.operator.name = this.corporation.name;
        this.operator.contact = this.corporation.signer;
        this.operator.signer = this.corporation.signer;
        this.operator.origin = this.corporation.origin;
        this.operator.title = this.corporation.title;
      } else {
        this.operator.contact = this.operator.name;
        this.operator.title = trustor.title;
      }
    },
    onDeleteOperator(cooperator) {
      this.cooperators = this.cooperators.filter(item => item !== cooperator);
    },
    onDeleteTrustor(cotrustor) {
      this.cotrustors = this.cotrustors.filter(item => item !== cotrustor);
    },
    coTrustorsToOperators(){
      // Stringifys cotrustors and rebuilds it as a new object, aka deep copy
      this.cooperators = JSON.parse(JSON.stringify(this.cotrustors));
    }
  }
};
</script>

<style>
</style>
